import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=f9999744&"
import script from "./PageTitle.vue?vue&type=script&lang=ts&"
export * from "./PageTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports